import axios from 'axios'
import { addDebugEntry, updateDebugEntry } from './debugStore'

let installed = false

function normalizeUrl (url) {
    if (!url) return ''
    try {
        return String(url)
    } catch {
        return ''
    }
}

function startPageLoadTimer () {
    if (typeof window === 'undefined') return

    const markLoaded = () => {
        const nav = performance.getEntriesByType('navigation')?.[0]
        const navDuration = nav
            ? Number(nav.loadEventEnd || nav.duration || 0)
            : 0
        const durationMs = navDuration > 0
            ? Math.round(navDuration)
            : Math.max(1, Math.round(performance.now()))
        addDebugEntry({
            type: 'pageload',
            label: 'window.load',
            status: 'ok',
            durationMs
        })
    }

    if (document.readyState === 'complete') {
        markLoaded()
        return
    }

    window.addEventListener('load', markLoaded, { once: true })
}

function setupAxiosPerfLogger () {
    if (installed) return
    installed = true

    axios.interceptors.request.use((config) => {
        const method = (config?.method || 'GET').toUpperCase()
        const url = normalizeUrl(config?.url)
        const debugId = addDebugEntry({
            type: 'api',
            method,
            url,
            status: 'pending',
            source: 'network'
        })

        config.__debugBar = {
            id: debugId,
            start: performance.now()
        }

        return config
    })

    axios.interceptors.response.use(
        (response) => {
            const debugMeta = response?.config?.__debugBar
            if (debugMeta?.id) {
                const durationMs = Math.max(0, Math.round(performance.now() - debugMeta.start))
                updateDebugEntry(debugMeta.id, {
                    status: response.status,
                    durationMs
                })
            }
            return response
        },
        (error) => {
            const config = error?.config
            const debugMeta = config?.__debugBar

            if (debugMeta?.id) {
                const durationMs = Math.max(0, Math.round(performance.now() - debugMeta.start))
                updateDebugEntry(debugMeta.id, {
                    status: error?.response?.status ?? 'ERR',
                    durationMs
                })
            }

            return Promise.reject(error)
        }
    )
}

startPageLoadTimer()
setupAxiosPerfLogger()
